import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { getIsCopyRunning } from '../../redux/selectors/CopyToolSelectors';

// Leaving mid-copy drops the destinations not yet written, so the browser asks first.
const warnBeforeUnload = (event: BeforeUnloadEvent) => {
  event.preventDefault();
  event.returnValue = '';
};

/** Asks before the page is left (reload, close, another site) while a copy runs. */
export const useWarnWhileCopying = () => {
  const isCopyRunning = useSelector(getIsCopyRunning);
  useEffect(() => {
    if (!isCopyRunning) return undefined;
    window.addEventListener('beforeunload', warnBeforeUnload);
    return () => window.removeEventListener('beforeunload', warnBeforeUnload);
  }, [isCopyRunning]);
};
